import { useState } from 'react';

import { IconProps } from '@flipster/react/icon/types';
import { css } from '@flipster/styled-system/css';
import { hstack } from '@flipster/styled-system/patterns';
import { Token, token } from '@flipster/styled-system/tokens';

interface ReactionButtonProps {
  Icon: React.ComponentType<IconProps>;
  color: Token;
  count: number;
  selected: boolean;
  disabled: boolean;
  onClick: (remove: boolean) => Promise<unknown>;
}
export const ReactionButton = ({ Icon, color, count, selected, disabled, onClick }: ReactionButtonProps) => {
  const [isReacted, setIsReacted] = useState(selected);
  const countWithoutMe = count - (selected ? 1 : 0);
  const updatedCount = isReacted ? countWithoutMe + 1 : countWithoutMe;
  return (
    <button
      className={css(
        hstack.raw({
          px: 8,
          py: 4,
          gap: 4,
          rounded: 8,
          _hover: {
            bg: 'background.interaction.hover',
          },
        }),
      )}
      onClick={async () => {
        try {
          setIsReacted((v) => !v);
          await onClick(isReacted);
        } catch {
          // suppress mismatch error and flip state
          setIsReacted((v) => !v);
        }
      }}
      disabled={disabled}
    >
      <Icon
        size={20}
        color={
          disabled
            ? token('colors.content.interaction.disabled')
            : isReacted
              ? token(color)
              : token('colors.content.default.level-2')
        }
      />
      {updatedCount > 0 && (
        <span
          className={css({
            textStyle: 'Text/S/Regular',
            color: disabled ? 'content.interaction.disabled' : 'content.default.level-2',
          })}
        >
          {formatCount(updatedCount)}
        </span>
      )}
    </button>
  );
};

const FormatCountLimit = 9999;
function formatCount(count: number) {
  if (count > FormatCountLimit) return `${new Intl.NumberFormat().format(FormatCountLimit)}+`;
  return new Intl.NumberFormat().format(count).toString();
}
